const ITEMS = [
  "Warm Luxury",
  "Bespoke Architecture",
  "Italian Marble",
  "Brass Mesh Partitions",
  "Pastel Palettes",
  "Turnkey Handover",
  "Delhi NCR · Lucknow · Gurgaon",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <div key={item} className="flex items-center">
        <span className="font-display text-[11px] lg:text-xs tracking-widest2 text-taupe uppercase px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-brass/70 shrink-0" />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee-ribbon" className="border-y border-hairline bg-sand py-5 overflow-hidden">
      <div className="flex w-max animate-marquee-drift">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
